/* eslint-disable no-restricted-imports */

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { CheckCircle, Close, FileCopy, Payment } from '@material-ui/icons';

export function PaymentLinkDialog({
  paymentLink,
  handleClosePaymentDialog,
  handleCopyPaymentLink,
}) {
  if (!paymentLink) return <></>;

  return (
    <Dialog open={Boolean(paymentLink)} onClose={handleClosePaymentDialog} maxWidth='md' fullWidth>
      <DialogTitle style={{ backgroundColor: '#4caf50', color: 'white' }}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box display='flex' alignItems='center' gap={1}>
            <CheckCircle />
            <Typography variant='h6'>Pagamento Gerado com Sucesso!</Typography>
          </Box>
          <IconButton onClick={handleClosePaymentDialog} size='small' style={{ color: 'white' }}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 24 }}>
        {paymentLink?.transactionId && (
          <Box
            marginBottom={3}
            padding={2}
            style={{
              backgroundColor: '#e3f2fd',
              borderRadius: 8,
              borderLeft: '4px solid #2196f3',
            }}
          >
            <Typography variant='caption' color='textSecondary' display='block'>
              ID da Transação
            </Typography>
            <Typography variant='body1' style={{ fontWeight: 600, color: '#1976d2' }}>
              {paymentLink.transactionId}
            </Typography>
          </Box>
        )}

        <Box
          marginBottom={2}
          padding={3}
          style={{
            backgroundColor: '#f5f5f5',
            borderRadius: 12,
            border: '2px solid #e0e0e0',
          }}
        >
          <Box display='flex' alignItems='center' marginBottom={2}>
            <Payment style={{ color: '#4caf50', marginRight: 8 }} />
            <Typography variant='subtitle1' style={{ fontWeight: 600 }}>
              Link de Pagamento
            </Typography>
          </Box>
          <Box
            padding={2}
            style={{
              backgroundColor: 'white',
              borderRadius: 8,
              wordBreak: 'break-all',
              border: '1px dashed #bdbdbd',
            }}
          >
            <Typography
              variant='body2'
              style={{ fontFamily: 'monospace', color: '#1976d2', fontSize: '0.9rem' }}
            >
              {paymentLink?.paymentLink || 'Link não disponível'}
            </Typography>
          </Box>
        </Box>

        <Box marginTop={3} paddingTop={2} borderTop='1px solid #e0e0e0'>
          <Grid container spacing={2} justifyContent='center'>
            <Grid item xs={12} sm={5}>
              <Button
                fullWidth
                onClick={handleCopyPaymentLink}
                variant='contained'
                size='large'
                style={{
                  backgroundColor: '#4caf50',
                  color: 'white',
                  padding: '12px 32px',
                  fontSize: '1rem',
                }}
                startIcon={<FileCopy />}
              >
                Copiar Link
              </Button>
            </Grid>
            <Grid item xs={12} sm={5}>
              <Button
                fullWidth
                onClick={() => window.open(paymentLink?.paymentLink, '_blank')}
                variant='outlined'
                size='large'
                style={{
                  borderColor: '#2196f3',
                  color: '#2196f3',
                  padding: '12px 32px',
                  fontSize: '1rem',
                }}
              >
                Abrir Link
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Typography
          variant='caption'
          color='textSecondary'
          style={{ display: 'block', textAlign: 'center', marginTop: 16 }}
        >
          O link pode ser compartilhado com o cliente via WhatsApp, e-mail ou qualquer outro meio
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
